export default "__VITE_ASSET__BFXXZ7As__"